/**
 * Mixpanel event adları. Serbest string kullanmak yerine hep buradan import edin
 * ki event isimleri tek yerden yönetilsin ve yazım hatası olmasın.
 * Format: "Object + Action", Title Case. Tekil aksiyonlar past tense (Created/Deleted),
 * süreli aksiyonlar Started/Ended çifti kullanır.
 */
export const EVENTS = {
  // Auth
  USER_SIGNED_UP: 'User Signed Up',
  USER_LOGGED_IN: 'User Logged In',
  USER_LOGGED_OUT: 'User Logged Out',
  PASSWORD_RESET_REQUESTED: 'Password Reset Requested',
  PASSWORD_RESET_COMPLETED: 'Password Reset Completed',

  // Agent lifecycle
  AGENT_CREATED: 'Agent Created',
  AGENT_UPDATED: 'Agent Updated',
  AGENT_DELETED: 'Agent Deleted',

  // Playground
  PLAYGROUND_SESSION_STARTED: 'Playground Session Started',
  PLAYGROUND_SESSION_ENDED: 'Playground Session Ended',

  // Public Agent Web Page (/agent/:id/web)
  PUBLIC_AGENT_CALL_STARTED: 'Public Agent Call Started',
  PUBLIC_AGENT_CALL_ENDED: 'Public Agent Call Ended',

  // Voice / TTS / STT
  VOICE_CREATED: 'Voice Created',
  TTS_TEST_RUN: 'TTS Test Run',
  STT_TEST_RUN: 'STT Test Run',

  // Tools
  TOOL_CREATED: 'Tool Created',
  TOOL_DELETED: 'Tool Deleted',

  // RAG
  RAG_COLLECTION_CREATED: 'RAG Collection Created',
  RAG_SOURCE_UPLOADED: 'RAG Source Uploaded',

  // SIP Trunk
  SIP_TRUNK_CREATED: 'SIP Trunk Created',

  // Call History
  CALL_DETAIL_VIEWED: 'Call Detail Viewed',
  CALL_FILTER_APPLIED: 'Call Filter Applied',
  CALL_TRANSCRIPT_SEGMENT_PLAYED: 'Call Transcript Segment Played',
  CALL_AUDIO_DOWNLOADED: 'Call Audio Downloaded',

  // API Tokens
  API_TOKEN_CREATED: 'API Token Created',
  API_TOKEN_REVOKED: 'API Token Revoked',
};

export default EVENTS;
